import { IOfferSpendByOfferScopeDetailsTableLang } from '../../../types/lang'

export const offerSpendByOfferScopeDetailsTableLang: IOfferSpendByOfferScopeDetailsTableLang = {
	offer_spend_by_offer_scope_details_table: {
		column_id: 'ID_ru',
		column_date: 'Date_ru',
		column_amount: 'Amount_ru',
		column_account: 'Account_ru',
		column_kt_group: 'KT Group_ru',
		column_offer: 'Offer_ru',
		column_notes: 'Notes_ru',
	}
}